<template>
  <v-app>
    <dashboard-core-app-bar @logout="handleLogout" />

    <dashboard-core-drawer />

    <dashboard-core-view ref="coreView" />

    <dashboard-core-settings />
  </v-app>
</template>

<script>
  import axios from 'axios';

  export default {
    name: 'DashboardIndex',

    components: {
      DashboardCoreAppBar: () => import('./components/core/AppBar'),
      DashboardCoreDrawer: () => import('./components/core/Drawer'),
      DashboardCoreSettings: () => import('./components/core/Settings'),
      DashboardCoreView: () => import('./components/core/View'),
    },

    data: () => ({
      expandOnHover: false,
    }),

    methods: {
      async handleLogout() {
        // 로그인 로직 (예: axios로 API 호출)
        const user = await axios.post('/api/logout');
        
        if (user && user.data.logout === 'success') {
          sessionStorage.removeItem('user');
          sessionStorage.removeItem('token');
          this.$store.commit('SET_USER', { user: null});
          delete axios.defaults.headers.common['Authorization'];
          this.$toast.success('성공적으로 로그아웃되었습니다!');

          if (this.$route.path !== '/') {
            this.$router.push('/');
          } else {
            this.$root.$emit('logout-event');
          }

        } else {
          console.log('로그아웃이 되지않았습니다.');
        }

      }
    }
  }
</script>
